// Import style
import './style.scss';

// Import utilities
import { isDefined } from '@automator/utilities';

// Import components of the Archive page
import IntegrationsSearch from '@pages/integrations/archive/search';

// Import images
import './img/integrations-page-banner-background.png';

// Import components of the Single page

/**
 * Invokes methods of both archive and single pages
 */
export default class Integrations {
	// eslint-disable-next-line require-jsdoc
	constructor() {
		new Archive();
		new Single();
	}
}

class Archive {
	// eslint-disable-next-line require-jsdoc
	constructor() {
		// Check if it's the integrations page
		if ( this.isIntegrationsPage ) {
			new IntegrationsSearch();
		}
	}

	/**
	 * Determines if the current page is the "Integrations" page
	 *
	 * @return {Boolean} True if the current page is the "Integrations" page
	 */
	get isIntegrationsPage() {
		return isDefined( document.getElementById( 'uap-integrations' ) );
	}
}

class Single {
	// eslint-disable-next-line require-jsdoc
	constructor() {
		// Check if it's the integrations page
		if ( this.isIntegrationsPage ) {
		}
	}

	/**
	 * Determines if the current page is the "Integrations" page
	 *
	 * @return {Boolean} True if the current page is the "Integrations" page
	 */
	get isIntegrationsPage() {
		return isDefined( document.getElementById( 'uap-integration' ) );
	}
}
